const getClientErrorLogger = (): Function => {
  const isProd = process.env.NODE_ENV === 'production';
  const isNewRelicAvailable = window?.newrelic?.noticeError;

  if (isProd && isNewRelicAvailable) {
    return window.newrelic.noticeError;
  }

  return console.error;
};

export default getClientErrorLogger;
